import { ThumbsUp, ThumbsDown } from "lucide-react";

export function HelpfulnessRating({ isSubmitting, onAnswer }) {
  return (
    <div className="space-y-5">
      <div className="flex justify-center gap-3 sm:gap-6">
        <button
          disabled={isSubmitting}
            onClick={() => onAnswer(true)}
          className="flex items-center gap-2 border-1 border-[#4793CD] bg-transparent hover:bg-[#4793CD]/10 
            text-[#4793CD] disabled:cursor-not-allowed font-medium py-2.5 px-8 text-base rounded transition-all duration-150 
            active:scale-[0.98] hover:shadow-md"
        >
          <ThumbsUp className="w-5 h-5" /> Yes
        </button>
        <button
          disabled={isSubmitting}
          onClick={() => onAnswer(false)}
          className="flex items-center gap-2 border-1 border-[#555555] bg-transparent hover:bg-[#555555]/10 
          text-[#555555] disabled:cursor-not-allowed font-medium py-2.5 px-8 text-base rounded 
          transition-all duration-150 active:scale-[0.98] hover:shadow-md"
        >
          <ThumbsDown className="w-5 h-5" /> No
        </button>
      </div>
    </div>
  );
}
